export enum ReportSpamType {
	personaStolenPhoto = "personaStolenPhoto",
	personaInappropriateContent = "personaInappropriateContent",
	personaSendingSpam = "personaSendingSpam"
}
